import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import theme from '../../constants/theme';
import { pageContainerSpacing, pageMaxWidth } from '../../constants/theme/theme';
import { ReactComponent as Cancel } from '../../icons/cancel.svg';
import { ReactComponent as WarningCircled } from '../../icons/warning-circled.svg';
import IAppFrameViewModel from '../../interfaces/umbracoNodes/appFrameViewModel';
import { PageContainer } from '../base/pageContainer/pageContainer';
import RichText from '../base/richText';

const AnnouncementWrapper = styled.div<{ isClosing: boolean }>`
	max-height: ${({ isClosing }) => (isClosing ? 0 : '135px')};
	overflow: hidden;
	transition: max-height 300ms ease;
`;

const PageContainerStyled = styled(PageContainer)`
	padding-block: 24px;
	background-color: ${theme.colorsV2.lightRed};

	@media only screen and (min-width: ${pageMaxWidth}px) {
		padding-inline: ${pageContainerSpacing.lg}px;
	}
`;

const AnnouncementContent = styled.div`
	display: grid;
	grid-template-columns: 1fr 32px;
`;

const TextMessage = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		flex-shrink: 0;
		margin-right: 8px;
	}
`;

const RichTextStyled = styled(RichText)`
	font-weight: ${theme.fonts.weight.medium};
	font-size: 16px;
	line-height: 1.2;
	color: ${theme.colors.white};

	a {
		color: ${theme.colors.white};
		text-decoration: underline;

		&:hover {
			color: ${theme.colors.white};
		}
	}
`;

const CloseButton = styled.button`
	display: flex;
	justify-self: end;
	align-self: center;
	background-color: transparent;
	cursor: pointer;

	svg {
		fill: ${theme.colors.white};
	}
`;

const AnnouncementBanner: FC = () => {
	const { appFrame }: { appFrame: IAppFrameViewModel } = useSelector(
		(state: { pageReducer: { appFrame: IAppFrameViewModel } }) => state.pageReducer
	);

	const [showAnnouncement, setShowAnnouncement] = useState(
		!!appFrame.Values.ShowAnnouncement &&
			appFrame.Values.AnnouncementText &&
			JSON.stringify(appFrame.Values.AnnouncementText) !== localStorage.getItem('lastClosedAnnouncement')
	);
	const [isClosing, setClosing] = useState(false);

	const closeAnnouncement = () => {
		localStorage.setItem('lastClosedAnnouncement', JSON.stringify(appFrame.Values.AnnouncementText || ''));
		setClosing(true);
		setTimeout(() => {
			setShowAnnouncement(false);
		}, 300);
	};

	return (
		<>
			{showAnnouncement && (
				<AnnouncementWrapper id="announcementBanner" aria-live="assertive" isClosing={isClosing}>
					<PageContainerStyled>
						<AnnouncementContent>
							<TextMessage>
								<WarningCircled />
								<RichTextStyled content={appFrame.Values.AnnouncementText} />
							</TextMessage>
							<CloseButton onClick={closeAnnouncement}>
								<Cancel />
							</CloseButton>
						</AnnouncementContent>
					</PageContainerStyled>
				</AnnouncementWrapper>
			)}
		</>
	);
};

export default AnnouncementBanner;
